import { Button, Combobox, lucideIcons, SearchInput } from '@round/creatorbase-ui';
import { CreatedByFilter } from './components/CreatedByFilter/CreatedByFilter';
import {
    CLEARED_FILTERS,
    getHasActiveFilters,
    getSelectedStatuses,
    OutreachRequestsFilterValues,
    STATUS_FILTER_OPTIONS,
} from './helpers';
import styles from './OutreachRequestsFilters.module.css';

const { X } = lucideIcons;

// Hold off refetching the list until the user pauses typing.
const SEARCH_DEBOUNCE_MS = 300;

const MAX_VISIBLE_STATUS_CHIPS = 1;

const CLEAR_LABEL = 'Clear';

type Props = {
    clientId: number | undefined;
    filters: OutreachRequestsFilterValues;
    onFiltersChange: (update: OutreachRequestsFilterValues) => void;
};

export const OutreachRequestsFilters = ({ clientId, filters, onFiltersChange }: Props) => (
    <div className={styles.container}>
        <div className={styles.control}>
            <SearchInput
                value={filters.search ?? ''}
                onChange={(event) => onFiltersChange({ search: event.target.value })}
                debounce={SEARCH_DEBOUNCE_MS}
                placeholder="Search requests…"
                aria-label="Search requests"
            />
        </div>

        <div className={styles.control}>
            <Combobox
                multiple
                items={STATUS_FILTER_OPTIONS}
                value={getSelectedStatuses(filters.status)}
                onValueChange={(selected) => onFiltersChange({ status: selected.map((item) => item.value).join(',') })}
                isItemEqualToValue={(a, b) => a.value === b.value}
                // A second status already overflows the control, so past one they read as a count instead.
                maxVisibleChips={MAX_VISIBLE_STATUS_CHIPS}
                placeholder="Select status…"
                noItemsFound="No statuses found"
                isClearable
            />
        </div>

        <div className={styles.control}>
            <CreatedByFilter
                clientId={clientId}
                value={filters.createdBy}
                onChange={(createdBy) => onFiltersChange({ createdBy })}
            />
        </div>

        {getHasActiveFilters(filters) && (
            <Button variant="bare" size="xs" onClick={() => onFiltersChange(CLEARED_FILTERS)}>
                <X /> {CLEAR_LABEL}
            </Button>
        )}
    </div>
);
